import type { CenterProps as MantineCenterProps } from '@mantine/core';
import { Center as MantineCenter } from '@mantine/core';

type CenterProps = MantineCenterProps;

export const Center = (props: CenterProps) => {
  return <MantineCenter {...props} />;
};
